<template>
    <div
        data-testid="step-uploadException"
        class="container container--slim step--upload-result step--upload-result--failed"
    >
        <h1 class="container__client-zone-header">
            {{ $t(`${TRANSLATION_KEY}.headerOne`) }}
        </h1>

        <div class="image-wrapper">
            <img class="w-80" src="@/assets/exception.svg" />
        </div>

        <p class="exception-message">
            {{ $t(`${TRANSLATION_KEY}.message`) }}
        </p>

        <div class="row" style="margin-top: 20px">
            <SubmitButton
                v-if="uploadDocumentCount === 1"
                data-testid="btn-uploadException-again"
                :action="action.UPLOAD_TRY_AGAIN"
                class="button button--submit"
                :data="{}"
            >
                {{ $t(`${TRANSLATION_KEY}.uploadAgain`) }}
            </SubmitButton>
            <button
                type="button"
                data-testid="btn-uploadException-skip"
                class="button button--skip"
                cy-data="go-to-personal-data"
                :disabled="isSubmitting"
                @click="handleSkip"
            >
                {{ $t(`${TRANSLATION_KEY}.skipAndContinue`) }} »
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import { defineComponent, computed, onMounted, ref } from 'vue';
import SubmitButton from '@/components/basic/buttons/SubmitButton.vue';
import { Action, ResponseStatus } from '@/constants/ajax';
import { useStore } from 'vuex';
import {
    INCREMENT_UPLOAD_DOCUMENT_COUNT,
    SET_LOCK,
    SET_STEP,
} from '@/constants/mutation-types';
import { useRouter } from 'vue-router';

export default defineComponent({
    name: 'UploadException',
    components: {
        SubmitButton,
    },
    setup() {
        const store = useStore();
        const router = useRouter();
        const TRANSLATION_KEY = 'steps.UploadException';
        const isSubmitting = ref(false);

        const isHybridFlow = computed(() => {
            const currentQuery = router.currentRoute.value.query;
            return (
                currentQuery.mobile === 'true' || currentQuery.qrCode === 'true'
            );
        });
        const uploadDocumentCount = computed(
            () => store.state.uploadDocumentCount
        );

        const action = Action;

        const handleSkip = async () => {
            if (isSubmitting.value || store.state.isLocked) return;

            isSubmitting.value = true;
            store.commit(SET_LOCK, true);

            if (isHybridFlow.value) {
                try {
                    const response = await store.state.ajaxService.post(
                        store.state.ajaxService.RESOURCES[
                            Action.SKIP_HYBRID_UPLOAD
                        ],
                        {
                            token: store.state.ajaxService.getToken(),
                        }
                    );

                    if (response.status === ResponseStatus.SUCCESS) {
                        await router.push({
                            name: 'mobileReturnToDesktop',
                            query: router.currentRoute.value.query,
                        });
                    }
                } finally {
                    store.commit(SET_LOCK, false);
                    isSubmitting.value = false;
                }

                return;
            }

            store.commit(SET_LOCK, false);

            try {
                await store.dispatch('ajax', {
                    action: Action.UPLOAD_SUMMARY,
                    data: {},
                });
            } finally {
                isSubmitting.value = false;
            }
        };

        onMounted(() => {
            store.commit(INCREMENT_UPLOAD_DOCUMENT_COUNT);
            store.commit(SET_STEP, 'uploadException');
        });

        return {
            handleSkip,
            uploadDocumentCount,
            TRANSLATION_KEY,
            action,
            isSubmitting,
        };
    },
});
</script>

<style>
.exception-message {
    text-align: center;
    font-size: 14px;
    margin-top: 50px;
}
</style>
